import { MemberApi } from '@/domains/auth/api'
import { RefreshResponse } from '@/domains/auth/api/types'

export class TokenRefresher {
  private static isRefreshing = false
  private static response: Promise<RefreshResponse> | null = null

  public static refresh() {
    if (!this.isRefreshing) {
      this.isRefreshing = true

      this.response = new Promise<RefreshResponse>(resolve => {
        resolve(MemberApi.refresh())
      }).finally(() => {
        this.isRefreshing = false
      })
    }

    return this.response
  }
}
